/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CommentHideIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Comment Hide',
} = {}): string | TemplateResult => {
  return html`<svg
    data-name="ICONS"
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M14.29395,16.66113c-.01416,0-.02881,0-.04346-.00098-2.57861-.14844-5.00049-2.45801-5.00049-3.7666,0-.34375.17432-.7041.54883-1.13379.27197-.31152.74609-.34473,1.05859-.07227.31201.27246.34424.74609.07227,1.05859-.08008.09082-.13184.16211-.1626.20996.19678.55176,1.75781,2.10254,3.56934,2.20605.41357.02441.72949.37891.70557.79199-.02246.39844-.35352.70703-.74805.70703Z"
      fill="currentColor"
    />
    <path
      d="M18.27869,15.16895c.74011-.62476,1.47131-1.50439,1.47131-2.27539,0-1.31055-2.43018-3.97949-5.26025-3.97949-.69208.00977-1.38092.17041-2.01227.4541l-.9472-.94727c-.29297-.29297-.76758-.29297-1.06055,0s-.29297.76758,0,1.06055l7.29932,7.29883c.14648.14648.33838.21973.53027.21973s.38379-.07324.53027-.21973c.29297-.29297.29297-.76758,0-1.06055l-.5509-.55078ZM14.5,10.41406c2.04883,0,3.66992,2.00391,3.75146,2.45703-.02869.16772-.383.69556-1.04382,1.22681l-3.55981-3.55957c.2804-.07446.56671-.12061.85217-.12427Z"
      fill="currentColor"
    />
    <path
      d="M6.25,19c-.09912,0-.19873-.01953-.29346-.05957-.27686-.11816-.45654-.38965-.45654-.69043v-3.25h-.75c-2.06787,0-3.75-1.68262-3.75-3.75v-5.5c0-2.06738,1.68213-3.75,3.75-3.75h10.5c2.06787,0,3.75,1.68262,3.75,3.75v2.04199c0,.41406-.33594.75-.75.75s-.75-.33594-.75-.75v-2.04199c0-1.24023-1.00928-2.25-2.25-2.25H4.75c-1.24072,0-2.25,1.00977-2.25,2.25v5.5c0,1.24023,1.00928,2.25,2.25,2.25h1.5c.41406,0,.75.33594.75.75v2.23633l.89502-.86133c.29785-.28711.77344-.27734,1.06006.01953.2876.29883.27832.77344-.02002,1.06055l-2.16504,2.08496c-.14209.1377-.32959.20996-.52002.20996Z"
      fill="currentColor"
    />
  </svg>`;
};
